import { Outlet } from "react-router-dom";
import SideNavbar from "../components/VTabBar/SideNavbar";
import {
  ChartBreakoutCircle,
  ChatBarIcon,
  DashboardIcon,
  GearIcon,
} from "../components/Icons";
import { RoutesType } from "./VTabBarLayout";
import UserDropdown from "../components/UserDropdown";
import { useEffect, useRef } from "react";

const routes = [
  {
    id: 1,
    route: "/investor/dashboard",
    name: "Dashboard",
    content: "This is investor dashboard page for manage investor tasks",
    icon: <DashboardIcon className="size-6" />,
    disabled: false,
  },
  {
    id: 2,
    route: "/investor/pool-summary",
    name: "Pool Summary",
    content: "investor tasks page for manage user pool summary",
    icon: <ChatBarIcon className="size-6" />,
    disabled: false,
  },
  {
    id: 4,
    route: "/investor/funded-deals",
    name: "Funded Deals",
    content: "investor Funded Deals page for manage Funded Deals",
    icon: <ChartBreakoutCircle className="size-6" />,
    disabled: false,
  },
] satisfies RoutesType;

const bottomLinks = [
  {
    route: "/investor/help-and-support",
    name: "Help & Support ",
    icon: <GearIcon className="size-6" />,
  },
];

export default function InvestorPanelLayout() {
  return (
    <main className="flex">
      <SideNavbar routes={routes} bottomLinks={bottomLinks} />

      <section className="flex-1 ml-[264px] min-h-screen pb-10 bg-[#EAECF0] transition-all duration-300 main_content">
        <Navbar />

        <section
          className="max-w-[1128px] mx-auto mt-20"
          id="main_content_outlet"
        >
          <Outlet />
        </section>
      </section>
    </main>
  );
}

function Navbar() {
  const navbarRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const handleScroll = () => {
      const el = navbarRef.current;
      if (!el) return;

      if (window.scrollY > 10) {
        el.classList.add("shadow-md");
        el.classList.remove("shadow-none");
        el.classList.add("bg-[#EAECF0]");
      } else {
        el.classList.add("shadow-none");
        el.classList.remove("shadow-md");
        el.classList.remove("bg-[#EAECF0]");
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav
      ref={navbarRef}
      className="fixed left-0 right-0 top-0 ml-[264px] z-20 shadow-none transition-all duration-300"
      id="dashboard_navbar"
    >
      <div
        className="max-w-[1128px] mx-auto flex justify-between py-4 items-center transition-all duration-500 ease-in-out"
        id="dashboard_navbar_container"
      >
        <h3 className="font-medium text-xl text-gray-800">
          Investor Dashboard
        </h3>

        <div className="flex items-center gap-6">
          <UserDropdown />
        </div>
      </div>
    </nav>
  );
}
